import * as React from 'react';
import ReactTooltip from 'react-tooltip';

export interface InfoButtonProps {
    /** Custom Id of info button */
    id : string,
    /** Where to place info tooltip */
    place? : "top" | "bottom" | "right" | "left",
    /** Type of tooltip to show */
    type? : "light" | "dark" | "success" | "warning" | "error" | "info",
    children : any,
    className? : string,
    variant? :   'primary'|'secondary'|'success'|'danger'|'warning'|'info'|'light'|'dark',
    iconClassName? : string
}

const InfoButton: React.FunctionComponent<InfoButtonProps> = (props: InfoButtonProps) => {
    const { id, place, type, children, className, variant, iconClassName } = props;
    return (
        <>
        <i data-tip data-for={`tooltip-${id}`} className={`material-icons bg-light rounded-circle text-${variant} cursor-on-hover ${iconClassName}`}>info</i>
        <ReactTooltip className={`info-tooltip ${className}`} id={`tooltip-${id}`} place={place} type={type}>
            {children}
        </ReactTooltip>
        </>
    );
}

InfoButton.defaultProps = {
    type : "info",
    variant : "info",
}

export default InfoButton;